import { HttpClient, HttpEvent } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PresignedPostResponse, UploadUrlRequest } from './assets-management.component';
import { environment } from "../../../environments/environment";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssetsManagementService {
  http = inject(HttpClient);

  createUploadUrl(request: UploadUrlRequest): Observable<PresignedPostResponse> {
    return this.http.post<PresignedPostResponse>(
      `${environment.yomaApiURL}/assets/upload-url`,
      request
    );
  }

  uploadToS3(response: PresignedPostResponse, file: File): Observable<HttpEvent<unknown>> {
    const formData = new FormData();

    Object.entries(response.fields).forEach(([key, value]) => {
      formData.append(key, value);
    });

    formData.append('file', file, file.name);

    return this.http.post(response.upload_url, formData, {
      observe: 'events',
      reportProgress: true
    });
  }

}
